import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    getActiveLocale,
    selectLocalePreference,
} from "../i18n/localePreference";
import type { SupportedLocale } from "../i18n/locales";

export type LocaleSaveState = "idle" | "saving" | "saved" | "pending";

export function useLocalePreference() {
    const { i18n } = useTranslation();
    const [saveState, setSaveState] = useState<LocaleSaveState>("idle");
    const locale = getActiveLocale();

    const selectLocale = useCallback(async (next: SupportedLocale) => {
        setSaveState("saving");
        try {
            await selectLocalePreference(next);
            setSaveState("saved");
        } catch {
            setSaveState("pending");
        }
    }, []);

    return {
        locale,
        selectLocale,
        saveState,
        languageVersion: i18n.language ?? i18n.resolvedLanguage,
    };
}
